import { Box, SystemProps, Text, TransparentButton } from "flicket-ui";
import styled from "styled-components";

import { useAtom } from "jotai";
import { Icon } from "~components";
import { ticketDetailsAtom, Details } from "../../common/modal.TicketDetails";
import {
  googleAnalyticsReleaseAtom,
  trackViewItemV4,
} from "~hooks/useGoogleAnalytics";
import { useOrganization } from "~hooks";

const ToolTip = styled(Box)<SystemProps>`
  position: relative;

  &&& button:hover {
    color: ${(p) => p.theme.colors.N600};
    opacity: 0.8;
    transition: background 0.2s, box-shadow 0.15s, border-color 0.2s, color 0.2s,
      opacity 0.2s;
  }
`;

type ListItemDetailsProps = Details & {
  ticketType?: any;
};

export const ListItemDetails = ({
  description,
  restrictions,
  name,
  ticketType,
}: ListItemDetailsProps) => {
  const [, setTicketDetails] = useAtom(ticketDetailsAtom);

  const { organization } = useOrganization();
  const [release] = useAtom(googleAnalyticsReleaseAtom);

  if (!description && !restrictions) {
    return null;
  }

  return (
    <ToolTip>
      <TransparentButton
        color="N600"
        onClick={() => {
          //  @ts-expect-error atom type issue while using strict:false
          setTicketDetails({ name, description, restrictions, addonImage });
          trackViewItemV4(organization, {
            item: ticketType,
            seated: true,
            release,
          });
        }}
      >
        <Icon color="N500" icon="info" fontSize={3} mr="1/2" />
        <Text fontSize={2} fontWeight="medium" lineHeight="medium">
          Details
        </Text>
      </TransparentButton>
    </ToolTip>
  );
};

export default ListItemDetails;
